// App.tsx

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./components/pages/HomePage";
import TrendingDestinations from "./components/pages/TrendingDestinations";
import About from "./components/pages/About";
import Premium from "./components/pages/Premium";
import Blog from "./components/pages/Blog";
// import Footer from "./components/header/Footer";


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<TrendingDestinations />} />
        <Route path="about" element={<About />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/blog" element={<Blog />} />
        {/* <Route path="/footer" element={<Footer/>} /> */}
        {/* You can add more routes here if needed */}
      </Routes>
    </Router>
  );
};

export default App;
